import axios from '@/axios';
import { $settings } from '@/provider/settings';
import { useOverviewStore } from '@/store/overview';
import { getFileExtension } from '@/utils/file';

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async fetchSharepointItemsByUrl(store, { url, context, type, subType }) {
      try {
        const { data } = await axios.get(
          `${$settings.middlewareURI}/graph/sharepoint/sites/items`,
          {
            params: { encodedURL: btoa(decodeURIComponent(url)) },
          },
        );
        const payload = data.map((item) => ({
          ...item,
          TYPE:
            item.TYPE === 'folder'
              ? item.TYPE
              : getFileExtension(item.TITLE || ''),
          itemId: item.ID,
        }));
        useOverviewStore().setOverview(
          {
            context,
            type,
            payload,
            subType,
          },
          (itemA, itemB) => itemA.ID === itemB.ID,
        );
        return useOverviewStore().setError({
          context,
          type,
          error: false,
          subType,
        });
      } catch (error) {
        useOverviewStore().setOverview({
          context,
          type,
          payload: [],
          subType,
        });
        useOverviewStore().setError({
          context,
          type,
          error: true,
          subType,
        });
        return error;
      }
    },

    async fetchSharepointIdsByUrl(store, { url, context, type, subType }) {
      try {
        const { data } = await axios.get(
          `${$settings.middlewareURI}/graph/sharepoint/sites/ids`,
          { params: { encodedURL: btoa(decodeURIComponent(url)) } },
        );
        return data;
      } catch (error) {
        useOverviewStore().setError({
          context,
          type,
          error: true,
          subType,
        });
        return error;
      }
    },

    async fetchItemsFromGraphApi(
      store,
      { content, context, type, subType, endpoint = 'search' },
    ) {
      let payload = [];
      const query =
        type === 'email'
          ? `email/${endpoint}?content=${content}`
          : `graph/${subType || type}/${content}`;
      const request = `${$settings.middlewareURI}/${query}`;

      try {
        const response = await axios.get(request);
        payload = response.data.DATA;

        if ((subType || type) === 'sharepoint') {
          payload = payload
            .filter((item) => item.SHAREPOINTIDS)
            .map((item) => ({
              ...item,
              TYPE:
                item.SIZE === 0 ? 'folder' : getFileExtension(item.TITLE || ''),
              itemId: item.ID,
            }));
        }

        return useOverviewStore().setOverview({
          context,
          type,
          payload,
          subType,
        });
      } catch (error) {
        console.error(error);
        return error;
      }
    },

    async fetchDriveItem(store, { driveId, itemId, context, type, subType }) {
      try {
        const response = await axios({
          method: 'get',
          url: `${$settings.middlewareURI}/graph/sharepoint/${driveId}/${itemId}/children`,
        });
        const payload = response.data;
        const modifiedPayload = payload.map((item) => ({
          ...item,
          TYPE:
            item.TYPE === 'folder'
              ? item.TYPE
              : getFileExtension(item.TITLE || ''),
          itemId: item.ID,
        }));
        return useOverviewStore().extendOverview(
          {
            context,
            type,
            payload: modifiedPayload,
            subType,
          },
          (a, b) => a.ID === b.ID,
        );
      } catch (error) {
        console.error(error);
        return error;
      }
    },

    async uploadSharepointDocuments(store, { file, driveId, parentFolderId }) {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('driveId', driveId);
      formData.append('parentFolderId', parentFolderId);
      return axios.post(
        `${$settings.middlewareURI}/graph/sharepoint/upload`,
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        },
      );
    },
  },

  getters: {},
};
